import { Link } from '@tanstack/react-router';
import type { App } from '@hangar/shared';
import { cn } from '@/lib/utils';
import { Icon } from '@/components/Icon';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip';

/** The arrow next to an app's name that opens its App page (design 29), where its name alone selects it. */
export function AppPageLink({ app, projectSlug, testId, className }: { app: App; projectSlug: string; testId?: string; className?: string }) {
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Link
          to="/projects/$slug/apps/$app"
          params={{ slug: projectSlug, app: app.slug }}
          data-testid={testId}
          aria-label={`Open the ${app.name} page`}
          className={cn('flex size-7 shrink-0 items-center justify-center rounded-md text-subtle outline-none transition-colors duration-150 hover:bg-accent hover:text-foreground focus-visible:ring-[3px] focus-visible:ring-ring/50 max-sm:size-9', className)}
        >
          <Icon name="arrow_forward" size={16} />
        </Link>
      </TooltipTrigger>
      <TooltipContent>Open the app page</TooltipContent>
    </Tooltip>
  );
}
